export const acercaDocs = [
    {
        titulo: "Manual de usuario",
        descripcion: `NutriPerformance presenta un manual completo sobre cómo operar y utilizar todos los aspectos del sistema. 
Hay instrucciones paso a paso en el manual de usuario donde puedes:

- Registrar los datos de los animales (género, peso, manejo, etc.).
- Elegir materias primas y productos subyacentes.
- Definir restricciones y costos.
- Formular dietas óptimas de bajo costo.
- Navegar y exportar los resultados obtenidos.

El manual ha sido creado para hacerlo lo más útil y accesible posible para agricultores, estudiantes y veterinarios que utilizan la herramienta en un entorno práctico.`,
        link: "/Docs/manual-usuario.pdf",
    },
    {
        titulo: "Manual técnico",
        descripcion: `La estructura interna, los componentes y el funcionamiento general de NutriPerformance se describen en el Manual Técnico. 
Incluye información sobre:

- Arquitectura Modelo-Vista-Controlador (MVC).
- Tecnologías utilizadas por él y las aplicaciones para las cuales se utilizan (React, JavaScript, HTML, CSS y MySQL).
- Estructura de la base de datos y comunicación entre módulos.
- Fórmulas y algoritmos usados para la formulación de dietas.
- Puntos sobre despliegue, mantenimiento y mejoras futuras.`,
        link: "/Docs/manual-tecnico.pdf",
    },
];